<template>
  <div class="shopCheck">
    <ul>
      <li>
        <h1>订到</h1>
        <p class="f16">无需开店，一键开通</p>
        <p class="f14">适用于线下转为线上，便捷订货系统</p>
        <el-button type="primary" @click="openShop(0)">立即开通</el-button>
      </li>
      <li>
        <h1>网店</h1>
        <p class="f16">享受电商全功能，货品卖全国</p>
        <p class="f14">一站式管理网店的店铺装修、商品、订单、营销、会员、资金等数据。</p>
        <el-button type="primary" @click="openShopNew()">开通网店</el-button>
      </li>
    </ul>
    <div class="shopCheck_bottom">不知道选哪个？欢迎拨打咨询热线：400-810-5353</div>
  </div>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>

<script>
export default {
  data() {
    return {
      isCheck: false,
    };
  },
  created() {
    this.$store.dispatch("orderHome/index/getQuerySingleShop").then((res) => {
      if (res.data) {
        if (res.data.audit !== 1) {
          window.location.href = `${process.env.VUE_APP_APP}mj/toSetbacks?toSCType=1&appid=1`;
        } else {
          window.top.location = `${process.env.VUE_APP_HOME}trade/default`;
        }
      } else {
        this.$store.commit("app/setIsZhanShi", true);
      }
    });
    this.$store.dispatch("shop/shop/getEnterpriseByBoId").then((res) => {
      if (res.data && res.data.Type === 0) {
        this.isCheck = true;
      }
    });
  },
  methods: {
    openShop(type) {
      if (this.isCheck) {
        this.$router.push(`/orderSystem/shopInfo/${type}`);
      } else {
        this.$message.error("请切换或注册企业(个体工商)身份后，提交入驻申请！");
      }
    },
    openShopNew() {
      if (this.isCheck) {
        this.$router.push(`/setup`);
        // window.location.href = `${process.env.VUE_APP_APP}shopInfo/approveQY?type=3&reEntered=&againShop=1&appid=1`;
      } else {
        this.$message.error("请切换或注册企业(个体工商)身份后，提交入驻申请！");
      }
    },
  },
};
</script>
